import React from "react";
import { useNavigate } from "react-router-dom";
import "./GPayPage.css";
import qrcode from "../img/paymentqrcode.jpg";
import { useTranslation } from "react-i18next";

const GPayPage = () => {
  const navigate = useNavigate();
  const {t} = useTranslation();
  const upiId = "niranmatrimony@oksbi";
  const mobile = "+91 90427 44056";

  return (
    <div className="gpay-container">
      {/* BACK BUTTON */}
      <button className="back-btn11" onClick={() => navigate(-1)}>
        ← {t("back")}
      </button>

      <div className="gpay-card">
        {/* LEFT SIDE */}
        <div className="left-section">
          <div className="brand-tag">{t("secure_upi_payment")}</div>
          <h2>{t("scan_and_pay")}</h2>

          <p className="subtitle">
            {t("upi_payment_desc")}
          </p>

          <div className="payment-details">
            <div className="detail-box">
              <span>{t("upi_id")}</span>
              <p>{upiId}</p>
            </div>

            <div className="detail-box">
              <span>{t("mobile_number")}</span>
              <p>{mobile}</p>
            </div>
          </div>

          {/* Payment Note */}
          <div className="payment-note">
            <h3>{t("payment_note")}</h3>

            <p>
              {t("payment_confirmation_note")}
            </p>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="right-section">
          <div className="qr-wrapper">
            <img src={qrcode} alt="UPI QR Code" className="qr-image" />
          </div>

          <p className="scan-text">
            Scan this QR using your mobile banking or UPI app
          </p>
        </div>
      </div>
    </div>
  );
};

export default GPayPage;
